import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { CommonService } from './shared/common.service';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private commonService: CommonService, private router: Router,private cookieService: CookieService ) {}

  canActivate(): boolean {
    return this.checkLogin();
  }

  canActivateChild(): boolean {
    return this.checkLogin();
  }

private checkLogin(): boolean {
  const isLoggedIn = this.cookieService.get('isLoggedIn') === 'true';
  console.log('AuthGuard checkLogin', isLoggedIn);

  if (!isLoggedIn) {
    this.router.navigate(['/email-login']);
    return false;
  }
  return true;
}

}
